export default "./images/favicon.png";